import { onMounted, onUpdated } from 'vue'
import hljs from 'highlight.js/lib/core'
import javascript from 'highlight.js/lib/languages/javascript'
import python from 'highlight.js/lib/languages/python'
import java from 'highlight.js/lib/languages/java'
import json from 'highlight.js/lib/languages/json'
import bash from 'highlight.js/lib/languages/bash'
import csharp from 'highlight.js/lib/languages/csharp'
import php from 'highlight.js/lib/languages/php'
import ruby from 'highlight.js/lib/languages/ruby'
import 'highlight.js/styles/vs2015.css'

// 注册所有可能用到的语言
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('python', python)
hljs.registerLanguage('java', java)
hljs.registerLanguage('json', json)
hljs.registerLanguage('bash', bash)
hljs.registerLanguage('shell', bash)
hljs.registerLanguage('curl', bash)
hljs.registerLanguage('csharp', csharp)
hljs.registerLanguage('php', php)
hljs.registerLanguage('ruby', ruby)

/**
 * 代码高亮 composable
 * @param selector CSS选择器，用于选择需要高亮的代码块
 */
export function useCodeHighlight(selector: string = 'pre code') {
  const highlightCodeBlocks = () => {
    // 获取所有匹配的代码块
    const codeBlocks = document.querySelectorAll(selector)
    
    codeBlocks.forEach((block) => {
      // 清除之前的高亮类，以便重新高亮
      if (block.classList.contains('hljs')) {
        block.classList.remove('hljs')
        // 清除所有语言相关的类
        const languageClasses = Array.from(block.classList).filter(cls => 
          cls.startsWith('language-') || cls.startsWith('hljs-')
        )
        languageClasses.forEach(cls => block.classList.remove(cls))
      }
      
      // 根据内容自动检测语言
      try {
        hljs.highlightElement(block as HTMLElement)
      } catch (error) {
        console.warn('代码高亮失败:', error)
      }
    })
  }

  // 在组件挂载时执行高亮
  onMounted(() => {
    // 使用 setTimeout 确保 DOM 已完全渲染
    setTimeout(() => {
      highlightCodeBlocks()
    }, 0)
  })

  // 在组件更新时重新执行高亮（处理动态内容）
  onUpdated(() => {
    setTimeout(() => {
      highlightCodeBlocks()
    }, 0)
  })

  return {
    highlightCodeBlocks
  }
}